import React,  {useState, useEffect} from "react"
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';


function DesafioFinal({dia, returnToCalendar}){
  localStorage.setItem("desafio25", "correcto");
  
  const [data, setData] = useState([{}])
  const [showModal, setShowModal] = useState(true);
  const [nome, setNome] = useState("");

  const handleCloseModal = () => {
    setShowModal(false);
  }
  
  let sessionId = localStorage.getItem("sessionId");
  console.log('https://www.araquelexplica-te.pt/custom/natal2022/get_nome.php?session_id=session_id='+sessionId)


  
  fetch('https://www.araquelexplica-te.pt/custom/natal2022/get_nome.php?session_id='+sessionId).then(
    res => res.json()
    ).then(
      data => {
        console.log('https://www.araquelexplica-te.pt/custom/natal2022/get_nome.php?session_id='+sessionId)
        console.log(data)
      }
  )
  
  

  const registarNome = () => {
    let sessionId = localStorage.getItem("sessionId");
    fetch('https://www.araquelexplica-te.pt/custom/natal2022/registar_nome.php?nome='+nome+"&session_id="+sessionId).then(res => res.json()).then(response => {
      alert("O teu nome foi registado.")
      setShowModal(false);
    });
  }


  //const handleShowModal = () => setShowModal(true);
  


  function getScore(){
    let correctos = 0;
    let incorrectos= 0;
    for (let i = 1; i < 25; i++) { 
      if(localStorage.getItem("desafio" + i) == "correcto"){
        correctos++;
      }
      if(localStorage.getItem("desafio" + i) == "errado"){
        incorrectos++;
      }
    }
    let result = {"correctos": correctos, "incorrectos": incorrectos}
    let score = (correctos / 24) * 100
    score = score.toFixed(2);
    // return JSON.stringify(result)

    

    return score + "% ("+correctos+" desafios certos e "+incorrectos+" desafios errados)"
  }



  useEffect(() => {
    fetch("https://www.araquelexplica-te.pt/custom/natal2022/desafio.php?dia="+dia).then(
      res => res.json()
    ).then(
      data => {
        setData(data)
      }
    )
  }, [dia])
  return(
    <div>
      {(typeof data.desafio === 'undefined')? (
        <p>A carregar desafio...</p>
      ):(
        <div>
          <img src={"https://www.araquelexplica-te.pt/custom/natal2022/static/desafios/25.png"} alt={"dia " + dia} width="80%"></img>  
          <div  class="row" style={{marginTop: "40px"}}>
                <div class="col">
          <button type="button" class="btn btn-outline-secondary btn-lg" style={{marginTop: "20px"}} onClick={() => returnToCalendar()}> Voltar ao calendário</button>
          </div>
          </div>
        </div>
      )}


      {/* Modal para resposta correcta */}
      <Modal 
      show={showModal} 
      onHide={handleCloseModal} 
      centered>
        <Modal.Header closeButton>
          <Modal.Title>Parabéns!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <p>Completaste o desafio de Natal de 2022!</p>

            <p>A tua pontuação foi {getScore()}</p>

            <p>Se quiseres podes registar o teu nome</p>

            <Form>
              <Form.Group className="mb-3" controlId="nome">
                <Form.Control type="text" placeholder="Nome" value={nome} onChange={(e)=>setNome(e.target.value)}/>
              </Form.Group>
            </Form>

          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Sair sem registar nome
          </Button>
          <Button variant="primary" onClick={registarNome}>
            Registar nome
          </Button>
        </Modal.Footer>
      </Modal>

    </div>
  )
}

export default DesafioFinal;